import React from "react";
import { CompatibleWithResult } from "./CompatibleWithResult";
import SpecialOrders from "~/common/SpecialOrders";
import ChromeAndProducts from "./ChromeAndProducts";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";
import ResourcesAndDownloads from "~/common/ResourcesAndDownloads";

const CompatibleWithPage = ({
  featureFlags = {},
  pageHeader,
  product,
  pagination,
  replacementParts,
  accessories,
  linkedResources,
  facetNavigation,
}: CompatibleWithResult) => {
  const hasProductDocuments = !!product?.documents?.length;
  const titleText = `Resources${hasProductDocuments ? " and Downloads" : ""}`;
  const hasWarrantyInformation =
    !!product?.disclaimers?.warrantyInformation &&
    product?.disclaimers?.showWarrantyInformation;
  const hasLinkedResources = !!linkedResources?.length;

  const backToProductPageH2 = (
    <h2 className="page-header-2">
      <a href={product ? product.link : ""}>Back to Product Page</a>
    </h2>
  );

  return (
    <FeatureFlagProvider featureFlags={featureFlags}>
      <div
        className="product-page compatibleWith container"
        data-module="initCompatibleWithPage"
      >
        <div className="text-content">
          <h1 className="page-header">{pageHeader}</h1>
          {product && product.link && backToProductPageH2}
        </div>
        <div id="page" className="showcase fixed-side-right clears">
          <div id="main">
            <div className="fixed-go-to-top clears no-sidebar">
              <div className="no-sidebar no-filter container-product-listing">
                <ChromeAndProducts
                  title="Replacement Parts"
                  displayProducts={replacementParts}
                  pagination={pagination}
                  facetNavigation={facetNavigation}
                />
                <ChromeAndProducts
                  title="Accessories"
                  displayProducts={accessories}
                  pagination={pagination}
                  facetNavigation={facetNavigation}
                />
              </div>
            </div>
          </div>
          <div id="sidebar" className="aside">
            {(!!product?.documents?.length ||
              (product?.disclaimers?.warrantyInformation &&
                product?.disclaimers?.showWarrantyInformation) ||
              (linkedResources && linkedResources.length > 0)) && (
              <ResourcesAndDownloads
                variant="plp"
                titleText={titleText}
                hasManufacturerText={false}
                manufacturerText={""}
                hasProductDocuments={hasProductDocuments}
                productDocuments={product?.documents ?? []}
                hasWarrantyInformation={hasWarrantyInformation}
                warrantyInformationText={
                  product?.disclaimers?.warrantyInformation ?? ""
                }
                hasLinkedResources={hasLinkedResources}
                linkedResources={linkedResources ?? []}
              />
            )}
            <SpecialOrders />
          </div>
        </div>
      </div>
    </FeatureFlagProvider>
  );
};

export default CompatibleWithPage;
